import React from "react";
import { TripBuddy } from "../types";
import TripEmptyState from "../emptyState";
import {
  getBuddyInitials,
  getBuddyName,
  getBuddyStatusLabel,
} from "../utils";

const TripBuddies = ({ buddies }: { buddies: TripBuddy[] }) => {
  return (
    <section className="trip-section">
      <div className="trip-section-header">
        <h2 className="trip-section-title">Invited buddies</h2>
        {buddies.length > 0 ? (
          <span className="trip-completion">{buddies.length} invited</span>
        ) : null}
      </div>

      {!buddies.length ? (
        <TripEmptyState message="No invited buddies available" />
      ) : (
        <div className="trip-buddies-list">
          {buddies.map((buddy) => {
            const name = getBuddyName(buddy);
            const statusLabel = getBuddyStatusLabel(buddy.status);

            return (
              <div key={buddy._id} className="trip-buddy-card">
                {buddy.profileImage ? (
                  <img
                    src={buddy.profileImage}
                    alt={name}
                    className="trip-buddy-avatar"
                  />
                ) : (
                  <span
                    className="trip-buddy-avatar-fallback"
                    aria-hidden="true"
                  >
                    {getBuddyInitials(buddy)}
                  </span>
                )}
                <div className="trip-buddy-meta">
                  <span className="trip-buddy-name">{name}</span>
                  <span className="trip-buddy-role">
                    {buddy.isTripCreator ? "Trip creator" : "Buddy"}
                  </span>
                </div>
                {statusLabel ? (
                  <span
                    className={`trip-buddy-status status-${buddy.status ?? 0}`}
                  >
                    {statusLabel}
                  </span>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default TripBuddies;
